import { render, staticRenderFns } from "./countpage.vue?vue&type=template&id=563f7880&scoped=true&"
import script from "./countpage.vue?vue&type=script&lang=js&"
export * from "./countpage.vue?vue&type=script&lang=js&"
import style0 from "./countpage.vue?vue&type=style&index=0&id=563f7880&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f7880",
  null
  
)

export default component.exports